<template>
  <div class="account-user-detail">
    <b-form>
      <b-form-group
        id="input-group-1"
        label="申請時間"
        label-for="created-time"
      >
        <b-form-input
          id="created-time"
          :value="$store.getters.userDetail.created_at"
          type="text"
          disabled
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" label="帳號" label-for="account">
        <b-form-input
          id="account"
          :value="$store.getters.userDetail.account"
          type="text"
          disabled
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" label="真實姓名" label-for="name">
        <b-form-input
          id="name"
          :value="$store.getters.userDetail.name"
          type="text"
          required
          placeholder=""
          disabled
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-3" label="email" label-for="email">
        <b-form-input
          id="email"
          :value="$store.getters.userDetail.email"
          type="text"
          required
          placeholder=""
          disabled
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-4" label="手機" label-for="phone">
        <b-form-input
          id="phone"
          :value="$store.getters.userDetail.phone"
          type="text"
          required
          placeholder=""
          disabled
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-5" label="投資資歷" label-for="seniority">
        <b-form-input
          id="seniority"
          :value="$store.getters.userDetail.seniority"
          type="text"
          required
          placeholder=""
          disabled
        ></b-form-input
        >年
      </b-form-group>
      <b-form-group
        id="input-group-6"
        label="自我介紹"
        label-for="introduction"
      >
        <b-form-textarea
          id="introduction"
          :value="$store.getters.userDetail.introduction"
          placeholder="請在 255 字內簡單自我介紹"
          rows="5"
          disabled
        ></b-form-textarea>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.account-user-detail {
  max-width: 300px;
  margin: auto !important;
}
</style>
